import angular from 'angular';

export default angular
  .module('csm.ui.busyScreen', [])
  .factory('BusyScreen', busyScreenFactory)
  .name;


busyScreenFactory.$inject = [];

  
/*****************************************************************************
 * Constructor Factory: BusyScreen
 *
 * Provides an object to manage a busy screen indication. While the indication
 * is visible, scrolling is disabled on the body of the page.
 * The busy animation is from: http://projects.lukehaas.me/css-loaders/.
 *
 * Note: A parent must have a non-relative position style set, otherwise, the
 *       placement will be based off of the body or first non-relative position
 *       parent, whichever is found first.
 *****************************************************************************/
/* @ngInject */ function busyScreenFactory() {
  /** Loader Animation Style Definition. */
  var loaderAnimation =
    'load' +
    '{' +
    '0%, 100%' +
    '{box-shadow: 0 -3em 0 0.2em #ffffff, 2em -2em 0 0em #ffffff, 3em 0 0 -1em #ffffff, 2em 2em 0 -1em #ffffff, 0 3em 0 -1em #ffffff, -2em 2em 0 -1em #ffffff, -3em 0 0 -1em #ffffff, -2em -2em 0 0 #ffffff; }' +
    '12.5% {box-shadow: 0 -3em 0 0 #ffffff, 2em -2em 0 0.2em #ffffff, 3em 0 0 0 #ffffff, 2em 2em 0 -1em #ffffff, 0 3em 0 -1em #ffffff, -2em 2em 0 -1em #ffffff, -3em 0 0 -1em #ffffff, -2em -2em 0 -1em #ffffff; }' +
    '25% {box-shadow: 0 -3em 0 -0.5em #ffffff, 2em -2em 0 0 #ffffff, 3em 0 0 0.2em #ffffff, 2em 2em 0 0 #ffffff, 0 3em 0 -1em #ffffff, -2em 2em 0 -1em #ffffff, -3em 0 0 -1em #ffffff, -2em -2em 0 -1em #ffffff; }' +
    '37.5% { box-shadow: 0 -3em 0 -1em #ffffff, 2em -2em 0 -1em #ffffff, 3em 0em 0 0 #ffffff, 2em 2em 0 0.2em #ffffff, 0 3em 0 0em #ffffff, -2em 2em 0 -1em #ffffff, -3em 0em 0 -1em #ffffff, -2em -2em 0 -1em #ffffff; }' +
    '50% {box-shadow: 0 -3em 0 -1em #ffffff, 2em -2em 0 -1em #ffffff, 3em 0 0 -1em #ffffff, 2em 2em 0 0em #ffffff, 0 3em 0 0.2em #ffffff, -2em 2em 0 0 #ffffff, -3em 0em 0 -1em #ffffff, -2em -2em 0 -1em #ffffff;}' +
    '62.5% {box-shadow: 0 -3em 0 -1em #ffffff, 2em -2em 0 -1em #ffffff, 3em 0 0 -1em #ffffff, 2em 2em 0 -1em #ffffff, 0 3em 0 0 #ffffff, -2em 2em 0 0.2em #ffffff, -3em 0 0 0 #ffffff, -2em -2em 0 -1em #ffffff;}' +
    '75% {box-shadow: 0em -3em 0 -1em #ffffff, 2em -2em 0 -1em #ffffff, 3em 0em 0 -1em #ffffff, 2em 2em 0 -1em #ffffff, 0 3em 0 -1em #ffffff, -2em 2em 0 0 #ffffff, -3em 0em 0 0.2em #ffffff, -2em -2em 0 0 #ffffff;}' +
    '87.5% {box-shadow: 0em -3em 0 0 #ffffff, 2em -2em 0 -1em #ffffff, 3em 0 0 -1em #ffffff, 2em 2em 0 -1em #ffffff, 0 3em 0 -1em #ffffff, -2em 2em 0 0 #ffffff, -3em 0em 0 0 #ffffff, -2em -2em 0 0.2em #ffffff;}' +
    '} ';

  /*------------------------------------------*/
  /* Maintain a reference to the body element */
  /*------------------------------------------*/
  var bodyElement = angular.element(document.getElementsByTagName('body')[0]);

  /*---------------------------------------------*/
  /* Add style block for busy screen functioning */
  /*---------------------------------------------*/
  bodyElement.append(
    angular.element(
      '<style>' +
        '.no-scroll                        { overflow: hidden; } ' +
        '.busyScreen, .busyScreen .overlay { position: fixed; top: 0; left: 0; width: 100%; height: 100%; cursor: wait}' +
        '.busyScreen  .content             { position: absolute; top: 50%; transform: translateY(-50%); width: 100%; text-align: center }' +
        '.busyScreen  .loader              { font-size: 20px; margin: 100px auto; width: 1em; height: 1em; border-radius: 50%;' +
        'position: relative; text-indent: -9999em; -webkit-animation: load 1.3s infinite linear;' +
        'animation: load 1.3s infinite linear; -webkit-transform: translateZ(0); -ms-transform: translateZ(0);' +
        'transform: translateZ(0); }' +
        '@-webkit-keyframes ' +
        loaderAnimation +
        '@keyframes ' +
        loaderAnimation +
        '</style>'
    )
  );

  /*------------------------------------*/
  /* Overlay div with loading animation */
  /*------------------------------------*/
  var busyDiv = angular
    .element("<div class='busyScreen' style='z-index: 1000000'></div>")
    .append(
      angular
        .element("<div class='overlay'></div>")
        .css('background-color', '#000000')
        .css('opacity', '0.7')
    )
    .append(
      angular.element(
        "<div class='content'><div class='loader'>Loading...</div></div>"
      )
    );

  /*--------------------------------------*/
  /* BusyScreen object to control overlay */
  /*--------------------------------------*/
  var mIsBusy = false;
  var busyScreen = {
    /***************************************************************************
     * isBusy */
    /**
     * Returns an indication that the overlay is shown.
     *
     * @return  Boolean value indicating overlay/screen is up
     ***************************************************************************/
    isBusy: function () {
      return mIsBusy;
    },

    /***************************************************************************
     * promise */
    /**
     * Sets the busy screen and clears it when the provided promise is finished.
     *
     * @param  Promise object to wait against
     ***************************************************************************/
    promise: function (promise) {
      var bs = this;
      bs.setBusy(true);
      promise['finally'](function () {
        bs.setBusy(false);
      });
    },

    /***************************************************************************
     * resetBusy */
    /**
     * Clears the busy screen if shown.
     ***************************************************************************/
    resetBusy: function () {
      if (this.isBusy()) this.setBusy(false);
    },

    /***************************************************************************
     * setBusy */
    /**
     * This function adds/removes the busyDiv to the body based on the busy
     * parameter. When busy, scrolling is disabled on the body tag with CSS.
     *
     * @param busy  Set/clear busy indication
     ***************************************************************************/
    setBusy: function (busy) {
      if ((mIsBusy = busy)) {
        bodyElement.append(busyDiv);
        bodyElement.addClass('no-scroll');
      } else {
        busyDiv.remove();
        bodyElement.removeClass('no-scroll');
      }
    }
  };

  return busyScreen;
}
